import React from "react";
import useTableFilters from "@/hooks/useTableFilters";
import {
  SalesCoordinatorFilter,
  ProjectFilter,
  TypeFilter,
  CompanyFilter,
  DateFilter,
  FilterActions,
  AccountManagerFilter,
} from "../components/company-filters";

export default function CollectedFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
  defaultFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      sales_coordinator: undefined,
      type: undefined,
      project: undefined,
      billing_date: undefined,
      ...defaultFilters,
    },
  });
  return (
    <div className="w-full p-4 space-y-4">
      <AccountManagerFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <SalesCoordinatorFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <ProjectFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <TypeFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <DateFilter
        fieldName="billing_date"
        label="Billing Date"
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <DateFilter
        fieldName="due_date"
        label="Due Date"
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <DateFilter
        fieldName="invoice_date"
        label="Invoice Date"
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <DateFilter
        fieldName="collected_date"
        label="Collected Date"
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <CompanyFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </div>
  );
}
